import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlService } from './api-url.service';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(
    private readonly http: HttpClient,
    private urlService: ApiUrlService
  ) { }

  fileUpload(type: any, folderName: any, image: any) {
    let headers = new HttpHeaders();
    headers.set('Content-Type', 'multipart/form-data');
    headers.set('Accept', "multipart/form-data");
    let params = new HttpParams();
    const formData: FormData = new FormData();
    formData.append('image', image);
    formData.append('folder_name', folderName);
    formData.append('type', type);
    return this.http.post(this.urlService.FILE_UPLOAD, formData, { params, headers })
  }

  excelFileUpload(type: any, folderName: any, image: any) {
    let headers = new HttpHeaders();
    headers.set('Content-Type', 'multipart/form-data');
    headers.set('Accept', "multipart/form-data");
    let params = new HttpParams();
    const formData: FormData = new FormData();
    formData.append('image', image);
    formData.append('folder_name', folderName);
    formData.append('type', type);
    return this.http.post(this.urlService.EXCEL_FILE_UPLOAD, formData, { params, headers })
  }
}
